module.exports = __webpack_public_path__ + "media/images/area/area_gunmaM400-ac5569ab50c5e8930fc0629c0f5f1455.jpg";